module.exports = __webpack_public_path__ + "assets/rslapppage.png";


//////////////////
// WEBPACK FOOTER
// ./libs/images/rslapppage.png
// module id = 357
// module chunks = 0